import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AppProviders from "./AppProviders";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // Ponašanje iz v7 uključeno unapred, da konzola ostane čista — inače v6 na
  // svako učitavanje ispiše dve najave, u kojima se prave greške lako izgube.
  //
  // `v7_relativeSplatPath` menja razrešavanje RELATIVNIH putanja unutar splat
  // ruta. Ovde postoji jedna takva ruta (`path="*"` → NotFound), a jedini link
  // u njoj je apsolutan, pa promene nema.
  //
  // `v7_startTransition` obavija promene stanja rutera u `React.startTransition`,
  // čime prelazi postaju prekidivi umesto hitnih. To se oseti kada navigacija
  // izaziva suspenziju; u ovoj aplikaciji nema ni `React.lazy` ni `<Suspense>`.
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <AppProviders>
      <App />
    </AppProviders>
  </BrowserRouter>
);
